export default "__VITE_ASSET__B99Y7keT__"